module.exports = __webpack_public_path__ + "static/media/favorite-blue.4569b901.svg";